import { Divider } from "@mui/material";
import React from "react";
import styles from "./HorizontalDivider.module.css";

export default function HorizontalDivider({ className }) {
  return <Divider className={`${styles.horizontalDivider} ${className}`} orientation="horizontal" />;
}
